<script setup>
import AOS from 'aos'

import AppHeader from '@/components/header.vue'
import AppFooter from '@/components/footer.vue'

onUpdated(() => {
  AOS.refresh()
})
</script>

<template>
  <AppHeader />
  <router-view />
  <AppFooter />
</template>
